export default {
    validation: {
        eircodeRequired: 'Please enter your eircode.',
        addressLine1Required: 'Please enter your address.',
        addressSelectRequired: 'Please select your address.',
        townRequired: 'Please enter your Town.',
        countyRequired: 'Please enter your County.',
        emailRequired: 'Please enter your email address.',
        phoneRequired: 'Please enter your phone number.',
    },
    errormessage: {
        noAddressFoundforEirCode: 'No address found',
        addressFinderNetworkError: 'Network error. Please try later.',
        eircodeNotConfirmed: 'Please confirm eircode.',
    },
};
